import { render, staticRenderFns } from "./CheckPenaltiesByCarModal.vue?vue&type=template&id=2f270878&scoped=true&"
import script from "./CheckPenaltiesByCarModal.vue?vue&type=script&lang=js&"
export * from "./CheckPenaltiesByCarModal.vue?vue&type=script&lang=js&"
import style0 from "./CheckPenaltiesByCarModal.vue?vue&type=style&index=0&id=2f270878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f270878",
  null
  
)

export default component.exports